<template>
	<div class="ml-10 flex items-center space-x-4">
		<!-- navi links on desktop -->

		<span v-for="item in items" :key="item.label">
			<page-link
				v-if="!item.children"
				:href="item.href"
				:class="
					isActive(item)
						? 'bg-green-700 text-white px-3 py-2 rounded-md text-sm font-medium'
						: 'text-white hover:bg-green-500 hover:bg-opacity-75 px-3 py-2 rounded-md text-sm font-medium'
				"
			>
				{{ __(item.label) }}
			</page-link>
			<ui-dropdown
				v-else
				button-class="flex text-white hover:bg-green-500 active:bg-green-700 focus:bg-green-700 px-3 py-2 rounded-md text-sm font-medium"
			>
				<template v-slot:button>
					<span
						:NO-class="
							isActive(item)
								? 'bg-green-700 text-white rounded-md text-sm font-medium'
								: 'text-white hover:bg-green-500 hover:bg-opacity-75 rounded-md text-sm font-medium'
						"
					></span>
					{{ __(item.label) }}
					<ui-icon
						class="ml-2 -mr-1 flex-shrink-0 h-5 w-5"
						name="chevron-down"
						stroke-width="1.5"
					/>
				</template>
				<template v-slot:items>
					<page-link
						v-for="child in item.children"
						:class="[
							'block px-4 py-2 text-gray-700',
							isActive(child)
								? 'bg-gray-100'
								: 'hover:bg-green-500 hover:bg-opacity-75',
						]"
						:key="child.label"
						:href="child.href"
						v-bind:list-label="child.label"
						>{{ __(child.label) }}</page-link
					>
				</template>
			</ui-dropdown>
		</span>
	</div>
</template>

<script>
export default {
	data() {
		let acl = this.$inertia.page.props.acl;
		return {
			acl: acl,
		};
	},
	computed: {
		items() {
			return [
				{
					label: "Users",
					icon: "users",
					href: "/admin/users",
				},
				{
					label: "Buy Offers",
					icon: "money",
					href: "/admin/offers_buy",
				},
				{
					label: "Sell Offers",
					icon: "mail",
					href: "/admin/offers_sell",
				},
				{
					label: "Auction Bids",
					icon: "mail",
					href: "/admin/auction_bids",
					acl: "increase_privileges",
				},
				{
					label: "Broker",
					icon: "zap",
					href: "/admin/alt_brokers",
					acl: "can_admin_broker",
				},
				{
					label: "Negotiations",
					icon: "message-square",
					href: "/admin/threads",
				},
				{
					label: "Contracts",
					icon: "book-open",
					href: "/admin/contracts",
				},
				{
					label: "Reports",
					icon: "percent",
					activeIf: "/admin/reports/",
					acl: "can_reports",
					children: [
						{
							label: "Inserted quantities",
							href: "/admin/stats/current_qty",
						},
						{
							label: "Listings by user type",
							href: "/admin/stats/current_qty_type",
						},
						{
							label: "Requests",
							href: "/admin/logs",
						},
						{
							label: "E-Mails",
							href: "/admin/email_logs",
						},
						{
							label: "Futures Kurse",
							href: "/admin/commodity_futures",
						},
						{
							label: "Statistics",
							href: "/admin/stats",
						},
						{
							label: "Preisindikation Heatmap",
							href: "/admin/stats/price_indications_heatmap",
						},
						{
							label: "Preisindikation Freischaltung Heatmap",
							href: "/admin/stats/price_indications_status_heatmap",
						},
						{
							label: "Active Users",
							href: "/admin/user_logs",
						},
						{
							label: "Export Users",
							href: "/admin/export/users",
						},
						{
							label: "Export Buy Offers",
							href: "/admin/export/offers_buy",
						},
						{
							label: "Export Sell Offers",
							href: "/admin/export/offers_sell",
						},
						{
							label: "Requests",
							href: "/admin/export/requests",
						},
					],
				},
				{
					label: "Market Compass",
					icon: "zap",
					href: "/admin/market-news",
					acl: "can_market_news",
				},
			].filter((item) => item.acl == null || this.acl[item.acl] == true);
		},
	},
	methods: {
		isActive(item) {
			let url = this.$inertia.page.url;
			return url.match(item.activeIf || item.href) !== null;
		},
	},
};
</script>
